import { render, staticRenderFns } from "./PaymentEtransferInstructions.vue?vue&type=template&id=1533da78&"
import script from "./PaymentEtransferInstructions.vue?vue&type=script&lang=js&"
export * from "./PaymentEtransferInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports